/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  useRouteError
} from 'react-router-dom';
import { BaseLayout } from '@hamajima/annualpass/layouts';
import PrivateRoute from './PrivateRoute';

const MemberInfo = lazy(() => import('@hamajima/annualpass/views/MemberInfo'));

const Login = lazy(() => import('@hamajima/annualpass/views/Login'));

const NotFound = lazy(() => import('@hamajima/share/views/NotFound'));

function RootErrorBoundary() {
  const error = useRouteError() as Error;
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload();
  }
  return null;
}

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback="Loading...">{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<BaseLayout />}>
          <Route index element={<Navigate to="memberinfo" replace />} />
          <Route path="memberinfo" element={lazyView(<MemberInfo />)} />
        </Route>
      </Route>
      <Route path="/login" element={lazyView(<Login />)} />
      <Route path="*" element={lazyView(<NotFound />)} />
    </Route>
  )
);

export default router;
